import { EmailOpts } from 'projectlink-common'
import endpoints from './endpoints'

const send = async (opts: EmailOpts[]) => {
  const body = JSON.stringify(opts)

  return fetch(endpoints.emails(), {
    method: 'post',
    body,
  })
}

const unsubscribe = async ({ email, channel }) => {
  return fetch(`${endpoints.emails()}/unsubscribe`, {
    method: 'post',
    body: JSON.stringify({ email, channel }),
  })
}

const emailService = {
  send,
  unsubscribe,
}

export default emailService
